<span *ngIf="icon$ | async as svg" [innerHTML]="svg"></span>
